import type { Component } from '@wix/thunderbolt-becky-types'
import { MASTER_PAGE_ID } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import { envRefs, themeRefs } from '@wix/thunderbolt-catharsis'
import type { ThemeFontsAndColorsCssDependencies } from './themeFontsAndColors.types'
import type { SelectorObj } from '../../shared.types'
import {
	getRootCssVars,
	getThemeBackColorsClasses,
	getThemeColorsClasses,
	getThemeFontsClasses,
} from './themeFontsAndColorsHelpers'
import type { Ref } from '@wix/thunderbolt-types'

export const themeFontsAndColorsCompNode = createCssCompNode('themeFontsAndColors', 'themeFontsAndColorsCssStyle', {
	getDependencies: (component: Component, refs: FeatureRefs<'themeFontsAndColors'> & { siteVariables: (component: Component | string) => Ref<any> }) => {
		if (component.id === MASTER_PAGE_ID) {
			return {
				shouldRenderWixAdsOnNavigation: envRefs.shouldRenderWixAdsOnNavigation,
				isWixAdsAllowed: envRefs.isWixAdsAllowed,
				isMobileView: envRefs.isMobileView,
				siteWidth: envRefs.siteWidth,
				shouldShowCoBrandingBanner: envRefs.shouldShowCoBrandingBanner,
				editorName: envRefs.editorName,
				colorData: themeRefs.siteColors,
				fontData: themeRefs.siteFonts,
				fontColorMap: themeRefs.fontColorMap,
				themeData: themeRefs.theme,
				textTheme: themeRefs.textTheme,
				experiments: envRefs.experiments,
				vhScalingFactor: envRefs.vhScalingFactor,
				directionWithOptInRtlSupport: refs.directionWithOptInRtlSupport(component),
				isBuilderComponentModel: envRefs.isBuilderComponentModel,
				brandColors: refs.siteVariables(component)
			}
		}

		return null
	},
	toViewItem: (__, deps: ThemeFontsAndColorsCssDependencies) => {
		if (!deps) {
			return null
		}

		const rootCssVars = getRootCssVars(deps)
		const themeFontsClasses = getThemeFontsClasses(deps)
		const themeColorsClasses = getThemeColorsClasses(deps)
		const themeBackColorsClasses = getThemeBackColorsClasses(deps)

		return {
			...rootCssVars,
			...themeFontsClasses,
			...themeColorsClasses,
			...themeBackColorsClasses,
		} as SelectorObj
	},
})
